/**
 * Tiny class-name combiner used by every UI primitive.
 * Mirrors shadcn's `cn()` helper.
 */
import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
